<template>
  <Card :padding="0"    dis-hover :bordered="false"  :style="'background:#fff;height:' + clientHeight +'px'">
    <div ref="toolbarcard" >
         <Card :padding="0" style="padding:14px 16px;border-radius:0px;" dis-hover>
            <ListBtnToolbar ref="menutoolbar" :config="menuToolbar"  :moduleMethod="moduleMethod"   @doAction="doAction"/>
        </Card>
    </div>
    <div ref="formcard">
    <Card :padding="0"  dis-hover :bordered="true"  style="padding-left:14px;padding-right:14px;padding-top:0px;padding-bottom:0px">
        <Formcards  ref="form"  :config="myConfig.formConfig" :dictData="dictData"/>
    </Card>
    </div>
    <Card :padding="0"  style="padding:14px 16px;" :bordered="false" dis-hover>
        <SimpleViewGrid  ref="grid" :config="myConfig.gridConfig"  :dictData="dictData" />
    </Card>
  </Card>
</template>

<script>
import ListBtnToolbar from './listbtntoolbar.vue';
import Formcards from './formcard.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
    name:'report',
    components:{ListBtnToolbar,Formcards},
    data () {
        return {
            myConfig:{
                titleType:2,
                divStyle:'padding:5px',
                title:'查询条件'
            },
            menuToolbar:{},
            gridToolbar:{},
            frontBtn: [{
                name:'searchData',text:'查询',icon:'custom-search'
            },{
                name:'clearData',text:'清除',icon:'custom-clean'
            }]
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    computed: {
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle='';
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        if (this.myConfig.gridConfig.resources === undefined) {
            this.myConfig.gridConfig.resources =this.config.resources;
        }
        if (this.myConfig.gridConfig.method === undefined) {
            this.myConfig.gridConfig.method = this.config.classPrefix + '.' +'query';
        }
        if (this.myConfig.gridConfig.response === undefined) {
            this.myConfig.gridConfig.response =  this.config.response;
        }
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.width = 1;
        this.myConfig.gridConfig.adjustHeight = 0;
        this.myConfig.gridConfig.adjustWidth = 0;
        this.myConfig.gridConfig.pageSize='small';
        
        if (this.myConfig.gridConfig.pageSizeNum === undefined) {
            this.myConfig.gridConfig.pageSizeNum = 20;
        }
        this.myConfig.gridConfig.items.forEach(el => {
            if (el.type !== 'CheckBox') {
                if (el.tooltip === undefined) {
                    el.tooltip = true;
                }
            }
        });
        this.myConfig.formConfig.titleType = this.myConfig.titleType;
        if (this.myConfig.formConfig.title === undefined) {
            this.myConfig.formConfig.title = this.myConfig.title;
        }
        if (this.myConfig.menuToolbar && this.myConfig.menuToolbar.items) {
            this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);     
        } 
        let frontBtn = []
        this.frontBtn.forEach(el => {
            let index = this.menuToolbar.items.findIndex(el2 => el2.name === el);
            if (index === -1) {
                frontBtn.push(el);
            }
        });
        this.menuToolbar.items = frontBtn.concat(this.menuToolbar.items);
        this.menuToolbar.mainButton = 'searchData';
        this.menuToolbar.mainButtonText ='查询';
        this.menuToolbar.ignoreModule = ['searchData','clearData'];
    },
    methods: {
        doAction (obj) {
            const method = obj.name;
            if (this.$parent[method]) {
                this.$parent[method]();
            } else {
                if (this[method]) {
                    this[method]();
                }
            }
        },
        clearData () {
            this.$refs.form.clearData();
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.clearData();
        },
        searchData() {
            this.$refs.form.checkValidate();
            let flag = this.$refs.form.isError();
            if (flag) {
                this.alert('必填项不允许为空');
                return false;
            }
            let data = this.$refs.form.getData();
            let searchParam = {};
            for (let pro in data) {
                if (data[pro] || data[pro] === 0) {
                    searchParam[pro] = data[pro];
                }
            }
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.setSearchBeforeSearchParam(searchParam);
            this.$refs.grid.refurbish();
        },
        exportData() {
            let data = this.$refs.grid.getData();
            if (data.length  === 0) {
                this.alert('请先查询数据');
                return false;
            }
            if (this.myConfig.gridConfig.dynamicColumnFlag) {
                this.$refs.grid.dynamicExportExcel();
            } else {
                if (this.myConfig.defaultExport) {
                    let _param = this.$refs.grid.getSearchParam();
                    let  moduleCode = this.getModulecode();
                    if (moduleCode) {
                        _param.moduleCode = moduleCode;
                    } else {
                        this.alert('模块号不能为空');
                        return;
                    }
                    _param.exporttype = 'excel';
                    let _baseUrl = this.myConfig.gridConfig.resources.replace('rest', 'exportReport');
                    let  _self  = this;
                    this.doExportReport(_baseUrl, this.myConfig.gridConfig.method, _param, _self);
                } else {
                    this.$refs.grid.export();
                }
               
            }
        },
        refurbish () {
            this.searchData();
        },
        getGrid () {
            return this.$refs.grid;
        },
        getForm () {
            return this.$refs.form;
        },
        setGridHeight() {
            let height = this.$refs.toolbarcard.offsetHeight  + this.$refs.formcard.offsetHeight + 60;
            this.$refs.grid.setOutsideHeight(height);
        }
    },
    mounted () {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.formcard, this.setGridHeight);
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.formcard, this.setGridHeight);
    }
};
</script>




// WEBPACK FOOTER //
// src/components/masterplate/report.vue